import { defineStore } from "pinia";
import { ref } from "vue";
import { setAuthToken } from "@/api/http";

export const useAuthStore = defineStore("auth", () => {
	const user = ref(null);
	const authToken = ref(null);
	const toggledSidebar = ref(false);

	function setUser(newValue) {
		if (newValue) {
			const merged = {
				...newValue.user,
				config: newValue.user?.config ?? newValue.config ?? {},
				features: newValue.user?.features ?? {},
			};
			user.value = merged;
			authToken.value = newValue.token;
			localStorage.setItem("user", JSON.stringify(merged));
			localStorage.setItem("authToken", newValue.token);
			setAuthToken(newValue.token);
		} else {
			user.value = null;
			authToken.value = null;
			localStorage.removeItem("user");
			localStorage.removeItem("authToken");
			setAuthToken(null);
		}
	}

	function toggleSidebar() {
		toggledSidebar.value = !toggledSidebar.value;
	}

	function closeSidebar() {
		toggledSidebar.value = false;
	}

	return {
		user,
		authToken,
		toggledSidebar,
		setUser,
		toggleSidebar,
		closeSidebar,
	};
});
